import { withAccessToken } from "../auth";
import { uploadAttachment } from "../api";
import uuid from "uuid/v4";
import pickBy from "lodash/pickBy";

export const PENDING = "PENDING";
export const UPLOADING = "UPLOADING";
export const DONE = "DONE";
export const ERROR = "ERROR";

export const UPLOAD_ADD = "UPLOAD/ADD";
export const UPLOAD_CANCEL_PENDING = "UPLOAD/CANCEL_PENDING";
export const UPLOAD_DELETE = "UPLOAD/DELETE";
export const UPLOAD_START = "UPLOAD/START";
export const UPLOAD_PROGRESS = "UPLOAD/PROGRESS";
export const UPLOAD_SUCCESS = "UPLOAD/SUCCESS";
export const UPLOAD_FAILURE = "UPLOAD/FAILURE";
export const LOG_OUT = "LOG_OUT";

export const addUpload = upload => {
  const id = uuid();
  return {
    type: UPLOAD_ADD,
    payload: {
      ...upload,
      id,
      progress: null,
      error: null,
      name: upload.file.name,
      byteSize: upload.file.size,
      contentType: upload.file.type
    },
    meta: { id }
  };
};

export const deleteUpload = id => ({
  type: UPLOAD_DELETE,
  meta: { id }
});

export const cancelAllPendingUploads = () => ({
  type: UPLOAD_CANCEL_PENDING
});

export const startUpload = upload => (dispatch, getState) => {
  const id = upload.id;
  dispatch(uploadStart(upload));

  return withAccessToken(accessToken => {
    return uploadAttachment(upload, {
      onProgress: e => dispatch(uploadProgress(id, e)),
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
      .then(response => {
        dispatch(uploadComplete(id));
        return response;
      })
      .catch(err => {
        dispatch(uploadFail(id, err));
      });
  });
};

export const getUploadsByStatus = (state, status) =>
  pickBy(state, upload => upload.status === status);

const uploadStart = upload => ({
  type: UPLOAD_START,
  payload: upload,
  meta: { id: upload.id }
});

const uploadProgress = (id, e) => {
  let progress = null;

  if (e && e.lengthComputable) {
    progress = e.loaded / e.total * 100;
  }

  return {
    type: UPLOAD_PROGRESS,
    payload: progress,
    meta: { id }
  };
};

const uploadComplete = id => ({
  type: UPLOAD_SUCCESS,
  meta: { id }
});

const uploadFail = (id, err) => ({
  type: UPLOAD_FAILURE,
  payload: err,
  meta: { id },
  error: true
});

export default (state = {}, action) => {
  switch (action.type) {
    case UPLOAD_ADD:
      return {
        ...state,
        [action.meta.id]: { ...action.payload, status: PENDING }
      };
    case UPLOAD_DELETE:
      return pickBy(state, (upload, key) => key !== action.meta.id);
    case UPLOAD_CANCEL_PENDING:
      return pickBy(state, upload => upload.status !== PENDING);
    case UPLOAD_START:
      return {
        ...state,
        [action.meta.id]: {
          ...state[action.meta.id],
          ...action.payload,
          status: UPLOADING
        }
      };
    case UPLOAD_PROGRESS:
      return {
        ...state,
        [action.meta.id]: {
          ...state[action.meta.id],
          progress: action.payload
        }
      };
    case UPLOAD_SUCCESS:
      return {
        ...state,
        [action.meta.id]: { ...state[action.meta.id], status: DONE }
      };
    case UPLOAD_FAILURE:
      return {
        ...state,
        [action.meta.id]: {
          ...state[action.meta.id],
          error: action.payload,
          status: ERROR
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/ducks/uploads.js